import { 
    REQUEST_TYPE_GET_REQUEST, REQUEST_TYPE_GET_SUCCESS, REQUEST_TYPE_GET_ERROR, 
    REQUEST_TYPE_GET_BY_KEY_REQUEST, REQUEST_TYPE_GET_BY_KEY_SUCCESS, REQUEST_TYPE_GET_BY_KEY_ERROR, 
    REQUEST_TYPE_ADD_REQUEST, REQUEST_TYPE_ADD_SUCCESS, REQUEST_TYPE_ADD_ERROR, 
    REQUEST_TYPE_EDIT_REQUEST, REQUEST_TYPE_EDIT_SUCCESS, REQUEST_TYPE_EDIT_ERROR, 
    REQUEST_TYPE_DELETE_REQUEST, REQUEST_TYPE_DELETE_SUCCESS, REQUEST_TYPE_DELETE_ERROR
} from "../constants/requestTypeConstants";

const initialState = {
    requestTypes: [],
    requestType: {},
    loading: false,
    success: null,
    error: null,
    requestTypeRequestedCount: 0,
};

export const requestTypeReducer = (state = initialState, action) => {
    switch (action.type)     {
        case REQUEST_TYPE_GET_REQUEST:
            return {
                ...state,
                requestTypeRequestedCount: ++state.requestTypeRequestedCount,
                loading: true,
            };
        case REQUEST_TYPE_GET_SUCCESS:
            return {
                ...state,
                loading: false,
                requestTypes: action.payload,
                success: true,
            };
        case REQUEST_TYPE_GET_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_TYPE_GET_BY_KEY_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_TYPE_GET_BY_KEY_SUCCESS:
            return {
                ...state,
                loading: false,
                requestType: action.payload,
                success: true,
            };
        case REQUEST_TYPE_GET_BY_KEY_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_TYPE_ADD_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_TYPE_ADD_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REQUEST_TYPE_ADD_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_TYPE_EDIT_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_TYPE_EDIT_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REQUEST_TYPE_EDIT_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        case REQUEST_TYPE_DELETE_REQUEST:
            return {
                ...state,
                loading: true,
            };
        case REQUEST_TYPE_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
            };
        case REQUEST_TYPE_DELETE_ERROR:
            return {
                ...state,
                loading: false,
                success: false,
                error: action.payload,
            };
        default:
            return state;
    }
}
